import axios from 'axios';
import { handleResponse, handleError } from '../../utils/axios';
import ENDPOINTS from 'constants/endpoints';

let CancelToken = axios.CancelToken;
let cancel;

const actionTypes = {
    REQUEST_CATEGORY_LIST: 'CATEGORIES/REQUEST_CATEGORY_LIST',
    RECEIVE_CATEGORY_LIST: 'CATEGORIES/RECEIVE_CATEGORY_LIST'
};

const fetchCategoryList = () => {
    return async (dispatch, getState) => {
        dispatch(requestCategoryList());
        const { initData } = getState();
        const results = await getCategoryLists(initData.version);
        dispatch(receiveCategoryList(results.data));
    };
};

const requestCategoryList = payload => ({
    type: actionTypes.REQUEST_CATEGORY_LIST,
    payload
});

const getCategoryLists = async version => {
    if (cancel !== undefined) {
        cancel();
    }

    try {
        let response = await axios.get(`${ENDPOINTS.GET_CATEGORY_LIST}`, {
            cancelToken: new CancelToken(function executor(c) {
                cancel = c;
            })
        });
        return handleResponse(response, version);
    } catch (e) {
        return handleError(e);
    }
};

const receiveCategoryList = payload => dispatch => {
    return dispatch({
        type: actionTypes.RECEIVE_CATEGORY_LIST,
        payload
    });
};

export default {
    fetchCategoryList,
    actionTypes
};



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/state/actions/categories.js